export const environment = {
    name: 'development',
    production: false
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts